<template>
  <div>
    <h3>发票张数：{{ dataSource.length }}</h3>
    <div v-for="(item, index) in dataSource"
         :key="index">
      <!-- 标题部分 -->
      <el-row style="margin-top: 12px"
              type="flex"
              justify="center"
              align="middle">
        <el-col class="text-center"
                :span="2">
          <span>张次</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>拆分发票ID</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>规格型号</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>单位</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>数量</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>开票名称</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>未税金额</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>税率</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>税额</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>价税合计</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>状态</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>发票号码</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>发票代码</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>开票日期</span>
        </el-col>
      </el-row>
      <!-- 数据 -->
      <el-row style="margin-top: 6px"
              type="flex"
              justify="center"
              align="middle"
              v-for="(subItem, idx) in item.ticket_json"
              :key="idx">
        <el-col class="text-center"
                :span="2">
          <span>{{ item.order_no }}</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>{{ item.id }}</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>{{ subItem.spec }}</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>{{ subItem.unit }}</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>{{ subItem.quantity * 1 !== 0 ? subItem.quantity : '' }}</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>{{ subItem.invoice_name_json.full_name }}</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>￥{{ subItem.no_tax_amount | seperateThousandsToFixed(2) }}</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>{{ subItem.tax_rate }}</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>￥{{ subItem.tax_amount | seperateThousandsToFixed(2) }}</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>￥{{ subItem.with_tax_amount | seperateThousandsToFixed(2) }}</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>{{ item.invoice_status_txt }}</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>{{ item.invoice_json.fphm }}</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>{{ item.invoice_json.fpdm }}</span>
        </el-col>
        <el-col class="text-center"
                :span="2">
          <span>{{ item.invoice_json.invoice_date }}</span>
        </el-col>
      </el-row>
      <div>
        <el-form :ref="`log${index}`"
                 :model="item"
                 label-width="50px"
                 size="medium">
          <el-form-item label="日志"
                        prop="log">
            <template>
              <div v-for="(logItem, index) in item.log">
                <span>{{ logItem.created_at }} {{ logItem.admin_name }} {{ logItem.desc }}</span>
              </div>
            </template>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    dataSource: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {}
  },
}
</script>

<style lang="scss">

</style>
<style lang="scss"
       scoped>
.text-center {
  text-align: center;
}
</style>
<style lang="scss"
       module>
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/ticket-split/InvoiceTicketSplitDetail.vue